/* ==========================================================================
   Hauser MX — consentimiento de cookies (fase 17)

   Marcado en snippets/hauser-cookies.liquid, estilo en hauser-cookies.css.

   Cómo decide si mostrar el aviso:
   1. Carga la Customer Privacy API de Shopify (`consent-tracking-api`).
   2. Si Shopify ya tiene una decisión del visitante, no molesta.
   3. Si no la tiene pero hay una copia local (localStorage `hauser_cookies`,
      12 meses), se la vuelve a entregar a Shopify en silencio: pasa cuando el
      navegador borró la cookie `_tracking_consent` pero no el almacenamiento.
   4. Si no hay ninguna de las dos, muestra el aviso.

   NO se usa `shouldShowBanner()`: esa función solo devuelve true en las
   regiones que la tienda configuró en Privacidad del cliente, y con México
   fuera de ellas el aviso no saldría nunca.

   Mientras el visitante no decide, manda la configuración de Shopify para
   su región (en México: estadística permitida). La Política de cookies lo
   dice así, a propósito: no se promete nada que el sitio no haga.

   Cualquier enlace a `#configurar-cookies` (footer, políticas, páginas
   legales) o botón con `data-hauser-cookies-abrir` abre el panel.
   ========================================================================== */
(function () {
  'use strict';

  var CLAVE = 'hauser_cookies';
  var VIGENCIA = 365 * 24 * 60 * 60 * 1000;

  var banner = document.querySelector('[data-hauser-cookies]');
  var panel = document.querySelector('[data-hauser-cookies-panel]');
  var anuncio = document.querySelector('[data-hauser-cookies-anuncio]');
  if (!banner || !panel) return;

  var api = null;
  var iniciado = false;

  /* ---------- Almacenamiento local (respaldo) ---------- */

  function leerLocal() {
    try {
      var v = JSON.parse(window.localStorage.getItem(CLAVE));
      if (v && typeof v.t === 'number' && Date.now() - v.t < VIGENCIA) return v;
    } catch (e) {}
    return null;
  }

  function guardarLocal(pref) {
    try {
      window.localStorage.setItem(CLAVE, JSON.stringify({
        analytics: !!pref.analytics,
        marketing: !!pref.marketing,
        t: Date.now()
      }));
    } catch (e) {}
  }

  /* ---------- Shopify ---------- */

  function decisionShopify() {
    if (!api || typeof api.currentVisitorConsent !== 'function') return null;
    try {
      var c = api.currentVisitorConsent() || {};
      if (c.analytics === 'yes' || c.analytics === 'no') {
        return { analytics: c.analytics === 'yes', marketing: c.marketing === 'yes' };
      }
    } catch (e) {}
    return null;
  }

  function entregarAShopify(pref, alTerminar) {
    if (!api || typeof api.setTrackingConsent !== 'function') {
      if (alTerminar) alTerminar();
      return;
    }
    try {
      api.setTrackingConsent({
        analytics: !!pref.analytics,
        marketing: !!pref.marketing,
        /* «Preferencias» en Shopify = recordar país/idioma: aquí son parte de
           las necesarias, el panel las declara siempre activas. */
        preferences: true,
        /* Venta/compartición de datos (categoría pensada para EE. UU.): va
           atada a publicidad, que es donde tendría sentido. */
        sale_of_data: !!pref.marketing
      }, function () {
        if (alTerminar) alTerminar();
      });
    } catch (e) {
      if (alTerminar) alTerminar();
    }
  }

  /* ---------- Aviso ---------- */

  function mostrarAviso() {
    banner.hidden = false;
    document.body.classList.add('hauser-cookies-abierto');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        banner.classList.add('is-visible');
      });
    });
  }

  function ocultarAviso() {
    if (banner.hidden) return;
    banner.classList.remove('is-visible');
    document.body.classList.remove('hauser-cookies-abierto');
    var fin = function () { banner.hidden = true; };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      fin();
    } else {
      window.setTimeout(fin, 320);
    }
  }

  function avisar(texto) {
    if (!anuncio) return;
    anuncio.textContent = '';
    window.setTimeout(function () { anuncio.textContent = texto; }, 60);
  }

  function decidir(pref, mensaje) {
    guardarLocal(pref);
    entregarAShopify(pref, function () {
      document.dispatchEvent(new CustomEvent('hauser:cookies', { detail: pref }));
    });
    ocultarAviso();
    if (panel.open) panel.close();
    avisar(mensaje);
  }

  /* ---------- Panel ---------- */

  function estadoActual() {
    return decisionShopify() || leerLocal() || { analytics: false, marketing: false };
  }

  function abrirPanel() {
    var actual = estadoActual();
    panel.querySelectorAll('[data-hauser-cookies-cat]').forEach(function (el) {
      el.checked = !!actual[el.getAttribute('data-hauser-cookies-cat')];
    });
    if (typeof panel.showModal === 'function') {
      if (!panel.open) panel.showModal();
    } else {
      panel.setAttribute('open', '');
    }
  }

  function cerrarPanel() {
    if (typeof panel.close === 'function' && panel.open) {
      panel.close();
    } else {
      panel.removeAttribute('open');
    }
  }

  function leerPanel() {
    var pref = { analytics: false, marketing: false };
    panel.querySelectorAll('[data-hauser-cookies-cat]').forEach(function (el) {
      pref[el.getAttribute('data-hauser-cookies-cat')] = el.checked;
    });
    return pref;
  }

  /* ---------- Eventos ---------- */

  document.addEventListener('click', function (e) {
    var el = e.target.closest(
      '[data-hauser-cookies-aceptar], [data-hauser-cookies-rechazar], [data-hauser-cookies-guardar], ' +
      '[data-hauser-cookies-abrir], [data-hauser-cookies-cerrar], a[href$="#configurar-cookies"]'
    );
    if (!el) return;

    if (el.matches('a')) e.preventDefault();

    if (el.hasAttribute('data-hauser-cookies-aceptar')) {
      decidir({ analytics: true, marketing: true }, 'Aceptaste todas las cookies.');
    } else if (el.hasAttribute('data-hauser-cookies-rechazar')) {
      decidir({ analytics: false, marketing: false }, 'Rechazaste las cookies opcionales.');
    } else if (el.hasAttribute('data-hauser-cookies-guardar')) {
      decidir(leerPanel(), 'Guardamos tu elección de cookies.');
    } else if (el.hasAttribute('data-hauser-cookies-cerrar')) {
      cerrarPanel();
    } else {
      abrirPanel();
    }
  });

  /* Clic en el fondo del <dialog> (fuera de la caja) = cerrar sin guardar. */
  panel.addEventListener('click', function (e) {
    if (e.target === panel) cerrarPanel();
  });

  /* Si alguien llega con #configurar-cookies en la URL, abrir el panel. */
  function revisarAncla() {
    if (window.location.hash === '#configurar-cookies') abrirPanel();
  }

  /* ---------- Arranque ---------- */

  function iniciar() {
    if (iniciado) return;
    iniciado = true;

    if (window.Shopify && window.Shopify.designMode) return;

    var deShopify = decisionShopify();
    var local = leerLocal();

    if (deShopify) {
      if (!local) guardarLocal(deShopify);
    } else if (local) {
      entregarAShopify(local);
    } else {
      mostrarAviso();
    }

    revisarAncla();
  }

  function cargarApi() {
    var S = window.Shopify;
    if (!S || typeof S.loadFeatures !== 'function') {
      iniciar();
      return;
    }
    /* Si la API tarda o falla, el aviso sale igual (con respaldo local). */
    var reloj = window.setTimeout(iniciar, 3000);
    try {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        window.clearTimeout(reloj);
        if (!error && S.customerPrivacy) api = S.customerPrivacy;
        iniciar();
      });
    } catch (e) {
      window.clearTimeout(reloj);
      iniciar();
    }
  }

  window.addEventListener('hashchange', revisarAncla);
  cargarApi();
})();
